import React, {useState} from 'react';
import {PageHeader} from "../../../../components/PageHeader";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import {getLicenseList} from "../../../../api/asset/LicenseService";
import LicenseListListType from "./subPages/LicenseListListType";
import {useDispatch} from "react-redux";
import {setKeys} from "../../../../redux/slice/searchSlice";
import useRequestData from "../../../../hooks/useRequestData";

function License() {

    const [listType, setListType] = useState(true)
    const [checked,setChecked] = useState([]);
    const dp = useDispatch();
    dp(setKeys({keys:"License"}))
    // const keys="license";

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook } =
        useRequestData(getLicenseList, initDate, 'license');

    return (
       <>
           <div className="common-container">
               <PageHeader header={"라이선스관리"} indicator={"자산관리 > 자산종합관리 > 라이선스관리"}/>

               <LicenseListListType
                       data={newData}
                       date={initDate}
                       pageInfo={pageInfo}
                       dataHook={dataHook}
                       checked={{checked: checked, setChecked: setChecked}} />
           </div>
       </>
    );
}

export default License;